import React, { Component, useEffect, useState } from 'react';
import {MdNotifications} from "react-icons/md"
import {BsFillCircleFill} from "react-icons/bs"
import { app,firestore } from '../../util/firebase';
import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const NotificatorAdmin = () => {

    const [hasNotif,setHasNotif]= useState(false)
    const [showed,setShowed]= useState(false)
    const [allMessages,setAllMessages]= useState([])
    const [allCommandes,setAllCommandes]= useState([])
    
    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"commandesClient"),snapshot=>{
            setAllCommandes(snapshot.docs.map(snap=>{
                let commande = snap.data()
                if(!commande.isValid && !commande.isArchived ){
                    setHasNotif(true)
                    return snap.data()
                }
                return null
            }))
        })
    },[])

    const allNotifications=()=>{
        if(allCommandes.length===0){
            return <p>Pas notification pour le moment</p>
        }else{
            return allCommandes.map((commande,index)=>{
                if(index < 1){
                    let message={
                        title:'Commandes non validés',
                        description:'Vous avez des commandes de clients qui ne sont pas encore validé'
                    }
                    return (
                        <Link onClick={showAllNotifs} to="listCurrentCommandes" className='text-decoration-none text-dark'>
                            <div key={index} className="text-start mx-2 fs-6">
                                <p className='fw-bold rounded'>{message.title}</p>
                                <p className='rounded'>{message.description}</p>
                                <hr></hr>
                            </div>
                        </Link>
                        
                    )
                }
            })
        }
    }

    const showAllNotifs=()=>{
        setShowed(!showed)
        setHasNotif(false)
        console.log(allCommandes.length);
    }
    return (
        <>
            
            <button className='d-inline' onClick={showAllNotifs} style={{background:'rgba(0,0,0,0)',border:'none'}}>
                <BsFillCircleFill className={hasNotif?'d-inline':'d-none'} style={{position:'absolute',color:'red',width:'10px',height:'10px',marginLeft:'15px',marginTop:'5px'}}></BsFillCircleFill>
                <MdNotifications className='ms-auto text-primary' style={{width:'30px',height:'30px'}}></MdNotifications>
            </button>

            <div className={showed?'d-inline shadow':'d-none'} style={{background:'#fff',transition:'1000ms',position:'absolute',width :'25vw',right:'-30px',top:'72px',borderRadius:'0px 0px 10px 10px'}}>
                {allNotifications()}
            </div>

        </>
    );
};

export default NotificatorAdmin;